export enum ModelSourceOptions {
    platform = 'platform',
    uploaded = 'uploaded',
    onPremise = 'onPremise',
}
